import toast from 'react-hot-toast';
import { create } from 'zustand';
import { Exercise as ExerciseEnum } from '@playbook-technologies/common-enums';
import { WorkoutItem } from '../pages/workout/models/workout.domain';

const storageKey = (influencerId: string) =>
  `playbookClipboardData-${influencerId}`;

const copiedLabel = (item: WorkoutItem) => {
  if (item.type === 10) return 'Tabata';
  if (item.type === 11) return 'HIIT';
  if (item.type === ExerciseEnum.Type.Multiple.value) return 'Circuit';
  return 'Exercise';
};

interface WorkoutClipboardState {
  data: WorkoutItem[];
  influencerId: string;
  copy: (newData: WorkoutItem) => void;
  clearAll: () => void;
  deleteItem: (index: number) => void;
}

const initialData = () => {
  const influencerId = window.location.pathname.split('/').reverse()[3];
  const storageData = localStorage.getItem(storageKey(influencerId));
  return {
    data: storageData ? JSON.parse(storageData) : [],
    influencerId: influencerId,
  };
};

export const useWorkoutClipboardStore = create<WorkoutClipboardState>(
  (set, get) => ({
    ...initialData(),
    copy: (newData: WorkoutItem) => {
      const storageData = localStorage.getItem(storageKey(get().influencerId));
      const currentData: WorkoutItem[] = storageData
        ? JSON.parse(storageData)
        : [];

      localStorage.setItem(
        storageKey(get().influencerId),
        JSON.stringify([...currentData, newData]),
      );
      toast.success(`${copiedLabel(newData)} copied to clipboard`);
      return set({ data: [...currentData, newData] });
    },
    clearAll: () => {
      localStorage.removeItem(storageKey(get().influencerId));
      return set({ data: [] });
    },
    deleteItem: (index: number) => {
      const filteredData = get().data.filter((d, i: number) => index !== i);
      localStorage.setItem(
        storageKey(get().influencerId),
        JSON.stringify(filteredData),
      );
      return set({ data: filteredData });
    },
  }),
);
